<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SkillInfoPanel from '../../../../../../skills/components/panels/SkillInfoPanel.vue'

import { SiteID } from '../../../../../../sites/models/site'
import { Skill } from '../../../../../../skills/models/skill'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { siteId, skill } = defineProps<{
  siteId: SiteID
  skill: Skill
}>()
</script>

<template>
  <SkillInfoPanel :site-id="siteId" :skill="skill" />
</template>
